export const FIXED = 'FIXED';
